//upsell modal
//   - button.add-to-cart (trigger button)

theme.upsellModal = async function() {

  var boobsCollectionItem = {
    image: 'https://cdn.shopify.com/s/files/1/0800/4863/files/38dbb3e8-47d8-4eee-a974-c6aafabfa3b6.jpg?v=1673883172',
    url: 'https://savedbythedress.com/collections/boobs-and-essentials',
    title: '',
    price: ''
  };
  
  if (getWithExpiry('upsellDisplayed1')) {
      return;
    }

  var productContainer = document.querySelectorAll('.product-section');
  if (productContainer.length === 0) {
    return;
  }

  productContainer = productContainer[0];

  var templateData = null;
  var productId = productContainer.getAttribute('data-product-id');
  if (!productId) {
    return;
  }


  templateData = [boobsCollectionItem]; // await loadUpsellProducts(productId);
  if (!templateData) {
    return;
  }
  loadData(templateData);
  

  
  
  var holderId = 'UpsellHolder';
  var selectors = {
    addToCart: 'button.add-to-cart',
  };

  var addToCartTriggers = document.querySelectorAll(selectors.addToCart);

  if (!addToCartTriggers.length) {
    return;
  }

  
  var holderDiv = document.getElementById(holderId);
  
  var modal = new theme.Modals('UpsellModal', 'upsell-modal', {
    solid: true,
    closeOffContentClick: false,
    bodyOpenClass: ['modal-open', 'upsell-modal-open'],
    bodyOpenSolidClass: ['model--solid']
    
  });
 
    
  var footerId = 'UpsellFooter';
  var footerholder = document.getElementById(footerId);
  footerholder.addEventListener('click', () => {
    modal.close();
  });

  document.addEventListener('ajaxProduct:added', (data) => {
    openUpsell();    
  });
  
  document.addEventListener('modalClose.UpsellModal', emptyUpsellHolder);
  

  function triggerAddToCartModal(evt) {
    openUpsell();

  }

  function openUpsell() {
    if (!templateData) {
      emptyUpsellHolder();
      return;
    }
    if (getWithExpiry('upsellDisplayed1')) {
      emptyUpsellHolder();
      return;
    }
      
    modal.open();

    if (!slideshow) {
      var defaults = {
        adaptiveHeight: false,
        avoidReflow: true,
        pageDots: true,
        prevNextButtons: false,
        contain: true,
        groupCells: true
      };
  
      var slideshow = holderDiv.querySelector('#Upsell-Slideshow');
  
  
      setTimeout(() => {
        var flickity = new theme.Slideshow(slideshow, defaults);        
      }, 100);
    }
    
    //setWithExpiry('upsellDisplayed1', '1', 86400000);
     
    
  }

  async function loadUpsellProducts(productId) {
    var url = 'https://new-app.savedbythedress.net/api/product/upsell/get-active?pid=' + productId;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((response) => {

      if (response.errors) {
        return null;
      }
      if (response.data.error === true) {
        return null;
      }
      return response.data.productData; 
      
        
    });
  }
  function emptyUpsellHolder() {
    
    document.dispatchEvent(new CustomEvent('upsellPopup:closed'));

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }, 500);
  }

  function loadData(data) {
    var slideshowContainer = holderDiv.querySelector('.slideshow-wrapper');

    console.log('slideshow wrapper clear and load', slideshowContainer);
    slideshowContainer.innerHTML = '';
    slideshowContainer.innerHTML = getTemplate();
  }

  function getTemplateDemo() {
    return `<div class="upsell-slider" id="Upsell-Slideshow">
                
                <div class="upsell-item">
                    <a href="https://savedbythedress.com/collections/boobies-and-essentials/products/black-strapless-and-backless-sticky-bra">
                      <div class="upsell-image">
                        <div class="text-spacing">
                          <img class="lazyloaded" src="//cdn.shopify.com/s/files/1/0800/4863/products/BlackBacklessStickyBra_360x.jpg?v=1658861375" alt="Select additional product">
                        </div>
                      </div>

                      <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">BLACK STRAPLESS AND BACKLESS STICKY BRA</div>
                        <div class="grid-product__price" style="color: white;">$ 17.95</div>
                      </div>
                    </a>
                </div>

                <div class="upsell-item">
                    <a href="https://savedbythedress.com/collections/boobies-and-essentials/products/beige-breast-lift-pasties">
                      <div class="upsell-image">
                        <div class="text-spacing">
                          <img class="lazyloaded" src="//cdn.shopify.com/s/files/1/0800/4863/products/BeigeBreastLiftPasties_360x.jpg?v=1658843568" alt="Select additional product">
                        </div>
                      </div>

                      <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">BEIGE BREAST LIFT PASTIES</div>
                        <div class="grid-product__price" style="color: white;">$ 12.95</div>
                      </div>
                    </a>
                </div>

                <div class="upsell-item">
                    <a href="https://savedbythedress.com/collections/boobies-and-essentials/products/nude-body-tape-and-nipple-cover-pack">
                    
                      <div class="upsell-image">
                        <div class="text-spacing">
                          <img class="lazyloaded" src="//cdn.shopify.com/s/files/1/0800/4863/products/NudeBodyTapeandNippleCoverPack_360x.jpg?v=1658844742" alt="Select additional product">
                        </div>
                      </div>

                      <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">NUDE BODY TAPE AND NIPPLE COVER PACK</div>
                        <div class="grid-product__price" style="color: white;">$ 16.95</div>
                      </div>
                    </a>
                </div>

                <div class="upsell-item">
                    <a href="https://savedbythedress.com/collections/boobies-and-essentials/products/nude-sticky-bra-11">
                    
                      <div class="upsell-image">
                        <div class="text-spacing">
                          <img class="lazyloaded" src="//cdn.shopify.com/s/files/1/0800/4863/products/IMG_6144_360x.jpg?v=1530648430" alt="Select additional product">
                        </div>
                      </div>

                      <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">NUDE STICKY BRA</div>
                        <div class="grid-product__price" style="color: white;">$ 12.95</div>
                      </div>
                  </a>
                </div>

                
              </div>`;
  }

  function getTemplate() {
    
    let out = `<div class="upsell-slider" id="Upsell-Slideshow">`;
    for( var v in templateData) {
      out += getTemplateItem(templateData[v]);
    }

    out += `</div>`;

    return out;
  }

  function getTemplateItem(oneItem, isCollection = false) {
    const collectionClass = isCollection ? 'collection' : '';
    return `<div class="upsell-item ${collectionClass}">
                    <a href="${oneItem.url}">
                      <div class="upsell-image">
                        <div class="text-spacing">
                          <img class="lazyloaded" src="${oneItem.image}" alt="Select additional product">
                        </div>
                      </div>

                      <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">${oneItem.title}</div>
                        <div class="grid-product__price" style="color: white;">$ ${oneItem.price}</div>
                      </div>
                    </a>
                </div>`;
  }
  


  function setWithExpiry(key, value, ttl) {
      const now = new Date();

      // `item` is an object which contains the original value
      // as well as the time when it's supposed to expire
      const item = {
          value: value,
          expiry: now.getTime() + ttl,
      }
      localStorage.setItem(key, JSON.stringify(item));
  }

  function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);

      // if the item doesn't exist, return null
      if (!itemStr) {
          return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expiry) {
          // If the item is expired, delete the item from storage
          // and return null
          localStorage.removeItem(key);
          return null;
      }
      return item.value;
  }

  console.log('fired upsell');

};